import { render } from "./RequestStatusForm.vue?vue&type=template&id=ad37dbf8"
import script from "./RequestStatusForm.vue?vue&type=script&lang=js"
export * from "./RequestStatusForm.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Tiresias\\Tiresias Project\\UI.Tiresias\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/RequestStatus/RequestStatusForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ad37dbf8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ad37dbf8', __exports__)) {
    api.reload('ad37dbf8', __exports__)
  }
  
  module.hot.accept("./RequestStatusForm.vue?vue&type=template&id=ad37dbf8", () => {
    api.rerender('ad37dbf8', render)
  })

}


export default __exports__